import { Component, OnInit, Input, ViewChild, Output, EventEmitter  } from '@angular/core';
import { DateTimeFunctions } from "src/app/shared/datetime-functions";
import { custom } from 'devextreme/ui/dialog';
import DataSource from 'devextreme/data/data_source';
import * as moment from 'moment';
import { forkJoin } from "rxjs";
import { DxDataGridComponent } from "devextreme-angular";
import { ProjectService } from '../../../modules/project/_api/services/project.service';
import { LanguageService } from '../../services/language.service';
import { AmsNotifierService } from '../../services/ams-notifier.service';
import { UserService } from '../../services/user.service';
import { TimeService } from '../../../modules/time/_api/services/time.service';

@Component({
  selector: 'app-grid-edit-week',
  templateUrl: './grid-edit-week.component.html',
  styleUrls: ['./grid-edit-week.component.css']
})
export class GridEditWeekComponent implements OnInit {
  @ViewChild(DxDataGridComponent, {static: false}) dataGrid: DxDataGridComponent
  updatedObject: any;
  selectedDate: Date;
  weekno_text: any;
  zoomLevels: string[] = [
    "month", "year", "decade", "century"
  ];
    employees: any[];
    employeesNotQuit: any[];
  employeeLookUpEnabled: boolean = true;

  timetypes: any[];
  projectsDataSource: DataSource;
  selectedEmployeeId: number;
  isEmployeeSelectShown: boolean;
  isEmployeeColumnShown: boolean;
  projectIdsDataSource: any[];
  dataSourceWeekApproval: any;
  isLoadIndicatorVisible: boolean;
  // employeeDataSource: CustomStore;
  
  mondayHeader = this.languageService.LNG("Label.Monday");
  tuesdayHeader = this.languageService.LNG("Label.Tuesday");
  wednesdayHeader = this.languageService.LNG("Label.Wednesday");
  thursdayHeader = this.languageService.LNG("Label.Thursday");
  fridayHeader = this.languageService.LNG("Label.Friday");
  saturdayHeader = this.languageService.LNG("Label.Saturday");
  sundayHeader = this.languageService.LNG("Label.Sunday");
  
  popupVisible = false;
  customerPopupDataSource: DataSource;
  projectsPopupDataSource: DataSource;
  projectPopupSearchEnabled = true;
  selectedProjectIdPopup: number;
  selectedCustomerIdPopup: number;
  fromCellPopup: any;
  fromCellSelectItem: any;
  selectedProjectItemPopup: any;

  editorElement: any;

  isClone: boolean = false;
  cloneData: any;

  headerFilterData = [];

  showUnconfirmed: boolean = true;
  editMode = "row";
  placeholderShortHours = "";
  placeholderShortMinutes = "";
  placeholderEmployeeSelect = "";
  placeholderProjectSelectSearch = "";
  todayText = this.languageService.LNG("Label.Today");
  projectText = this.languageService.LNG("Label.Project");
  employeeText = this.languageService.LNG("Label.Employee");
  timetypeText = this.languageService.LNG("Label.TimeType");
  copyText = this.languageService.LNG("Label.Copy");
  validateHoursMessage = this.languageService.LNG("Label.Cannot.Enter.More.Than.23.Hours");
  validateMinutesMessage = this.languageService.LNG("Label.Cannot.Enter.More.Than.59.Minutes");
  colIndexSeparatorStart = 5;
  colIndexSeparatorEnd = 11;
  colSeparatorCaptions = [
    this.mondayHeader, this.tuesdayHeader, this.wednesdayHeader, this.thursdayHeader, this.fridayHeader, this.saturdayHeader, this.sundayHeader, this.placeholderShortHours, this.copyText
  ]
  allowAdding = true;
    
  @Input() allowEditUnconfirmed = true;
  @Input() allowEditConfirmed = true;
  @Output() loading = new EventEmitter<boolean>();//emit event to parent(project-portal.component) to show load indicator
  @Output() loadRecords = new EventEmitter<any>();
  @Output() refresh = new EventEmitter<void>();
  @Output() selectedDetail = new EventEmitter<any>();
  @Output() showDetail = new EventEmitter<boolean>();
  @Output() rowInserting = new EventEmitter<any>();
  @Output() rowUpdating = new EventEmitter<any>();
  @Output() rowRemoving = new EventEmitter<any>();
  @Output() initNewRow = new EventEmitter<any>();
  @Output() cellPrepared = new EventEmitter<any>();

  constructor(private dateTimeFunctions: DateTimeFunctions, private projectService: ProjectService, private languageService: LanguageService, 
    private amsNotifierService: AmsNotifierService, private userService: UserService, private timeService: TimeService) {
    
    
    this.selectedDate = new Date();
    this.weekno_text = this.dateTimeFunctions.findWeekFromDate(this.selectedDate);
    this.isEmployeeSelectShown = true;
    this.placeholderShortHours = this.languageService.LNG("Label.ShortHours");
    this.placeholderShortMinutes = this.languageService.LNG("Label.ShortMinutes");
    this.placeholderEmployeeSelect = this.languageService.LNG("Label.Employee");
    this.placeholderProjectSelectSearch = this.languageService.LNG("Label.MinThreeCharacters");

    this.setDayHeaders();
    if (!this.isEmployeeSelectShown) {
      this.colIndexSeparatorStart = 4;
      this.colIndexSeparatorEnd = 10;
    }

   }

   setDayHeaders() {
     
    let startOfWeek = moment(this.selectedDate).startOf('isoWeek');
    this.mondayHeader = this.languageService.LNG("dxAllAms.DaysAbbr.monday") + " " + startOfWeek.format("DD.MM");
    this.tuesdayHeader =this.languageService.LNG("dxAllAms.DaysAbbr.tuesday") + " " + moment(startOfWeek).add(1, 'day').format("DD.MM");
    this.wednesdayHeader = this.languageService.LNG("dxAllAms.DaysAbbr.wednesday") + " " + moment(startOfWeek).add(2, 'day').format("DD.MM");
    this.thursdayHeader = this.languageService.LNG("dxAllAms.DaysAbbr.thursday") + " " + moment(startOfWeek).add(3, 'day').format("DD.MM");
    this.fridayHeader = this.languageService.LNG("dxAllAms.DaysAbbr.friday") + " " + moment(startOfWeek).add(4, 'day').format("DD.MM");
    this.saturdayHeader = this.languageService.LNG("dxAllAms.DaysAbbr.saturday") + " " + moment(startOfWeek).add(5, 'day').format("DD.MM");
    this.sundayHeader = this.languageService.LNG("dxAllAms.DaysAbbr.sunday") + " " + moment(startOfWeek).add(6, 'day').format("DD.MM");
    this.colSeparatorCaptions = [
      this.mondayHeader, this.tuesdayHeader, this.wednesdayHeader, this.thursdayHeader, this.fridayHeader, this.saturdayHeader, this.sundayHeader, this.placeholderShortHours, this.copyText
    ]
   }

  ngOnInit() {
    
    this.setLookUps();
    
    this.headerFilterData = [];
    if (this.showUnconfirmed) {
      this.headerFilterData.push( {
        text: this.languageService.LNG("Label.Unconfirmed"),   
        value: ["StatusId", "=", 2]
      });
    }
    this.headerFilterData.push( {
      text: this.languageService.LNG("Label.Confirmed"),
      value: ["StatusId", "=", 3]   
    });
    this.headerFilterData.push( {
      text: this.languageService.LNG("Label.Is.Approved"),
      value: ["StatusId", "=", 4]  
    });
    this.headerFilterData.push( {
      text: this.languageService.LNG("Label.Ready.For.Salary"),
      value: ["StatusId", "=", 5]  
    });
    this.headerFilterData.push( {
      text: this.languageService.LNG("Label.Transferred.Salary"),
      value: ["StatusId", "=", 99]  
    });
    
    setTimeout(() => {
      this.loadListRecords(true);
    });
    if (!this.allowEditUnconfirmed && !this.allowEditConfirmed) {
      this.allowAdding = false;
    }
    // this.getTimeTypes();
  }

  getDataSourceProjects(e) {
    
    return this.projectService.get().toPromise();
  }

  setLookUps() {
    
    // project
    this.projectsDataSource = new DataSource({
      key: "ProjectId",
      paginate: false, //Eirik 11.08.20 v2.0.31.3 task 318 - when paginate is false the list is not updated when scrolling to the bottom. had an issue where the list added the same projects again when the user scrolled to the bottom of the list
      load: (loadOptions) => {
        
        if (this.projectIdsDataSource && this.projectIdsDataSource.length > 0) {
          this.loading.emit(true);
          if (loadOptions.searchValue != null && loadOptions.searchValue.length >= 3) {
            return this.projectService.getBySearchTextAndProjectIdsVM(loadOptions.searchValue.toString(), this.projectIdsDataSource).toPromise().then((data: any) => {
              this.loading.emit(false);
              return data;
            });
          }
          else {
            return this.projectService.getByIdsVM(this.projectIdsDataSource).toPromise().then((data: any) => {
              this.loading.emit(false);
              return data;
            });
          }
        }
        else {
          if (loadOptions.searchValue) {
            return this.projectService.getBySearchText(loadOptions.searchValue.toString()).toPromise();
          }
          else {
            return [];
          }
        }
      },
      byKey: (key) => {
        if (key > 0) {
          
          return this.projectService.getById(key).toPromise();
        }
        else {
          let p: any = {
            ProjectId: -1,
            CustomerId: -1,
            ProjectNumber: "",
            ProjectDisplayName: ""
          }
          return p;
        }
      }
    });

    //customer popup
    this.customerPopupDataSource = new DataSource({
      key: 'CustomerId',
      loadMode: "raw",
      load: (loadOptions) => {
        return this.projectService.getCustomers().toPromise();
      },
      byKey: (key) => {
        return this.projectService.getCustomer(key).toPromise();
      }
    });

    //project popup
    this.projectsPopupDataSource = new DataSource({
      key: "ProjectId",
      paginate: false, //Eirik 11.08.20 v2.0.31.3 task 318 - when paginate is false the list is not updated when scrolling to the bottom. had an issue where the list added the same projects again when the user scrolled to the bottom of the list
      load: (loadOptions) => {
        
        this.loading.emit(true);
        if (loadOptions.searchValue != null) {
          if (loadOptions.searchValue.length >= 3) {
            return this.projectService.getBySearchTextAndProjectIdsVM(loadOptions.searchValue.toString(), this.projectIdsDataSource).toPromise().then((data: any) => {
              this.loading.emit(false);
              return data;
            });
          }
          else {
            this.loading.emit(false);
          }
        }
        else {
          if (this.selectedCustomerIdPopup > 0) {
            return this.projectService.getByCustomerId(this.selectedCustomerIdPopup).toPromise().then((data: any) => {
              this.loading.emit(false);
              return data;
            });
          }
          else {
            return this.projectService.getByIds(this.projectIdsDataSource).toPromise().then((data: any) => {
              this.loading.emit(false);
              return data;
            });
            //return "";
          }
        }
      },
      byKey: (key) => {
        
        return this.projectService.getById(key).toPromise();
      }
    });
  }
  
  onToolbarPreparing(e) {
    if (this.allowEditConfirmed || this.allowEditUnconfirmed) {
      e.toolbarOptions.items.unshift( {
            location: 'after',
            widget: 'dxButton',
            options: {
                icon: 'copy',
                title: this.languageService.LNG("Label.Copy"),
                onClick: this.onCopySelected.bind(this)
            }
        },
        {
            location: 'after',
            widget: 'dxButton',
            options: {
                icon: 'trash',
                title: this.languageService.LNG("Label.Delete"),
                onClick: this.onDeleteSelected.bind(this)
            }
        });
    }
  }

  onCopySelected() {
    
    let selectedRowsData = this.dataGrid.instance.getSelectedRowsData();
    if (selectedRowsData.length > 0) {
      for (let i = 0; i < selectedRowsData.length; i++) {
        this.isClone = true;
        this.cloneData = selectedRowsData[i];
        this.dataGrid.instance.addRow();
      }
    }
  }

  onDeleteSelected() {
    
    
    let myDialog = custom({
      title: this.languageService.LNG("Label.Delete"),
      messageHtml: this.languageService.LNG("Label.Do.You.Want.To.Delete.The.Selected.Rows"),
      buttons: [{
          text: this.languageService.LNG("Label.Yes"),
          onClick: (e) => {
              return true;
          }
      }, {
        text: this.languageService.LNG("Label.No"),
        onClick: (e) => {
            return false;
        }
    }, 
      ]
    });
    
    myDialog.show().then((bConfirm) => {
      
    if (bConfirm) {
      this.loading.emit(true);
      let selectedRowsData = this.dataGrid.instance.getSelectedRowsData();
      if (selectedRowsData.length > 0) {
        let rowsToDelete = [];
        for (let i = 0; i < selectedRowsData.length; i++) {
          if (selectedRowsData[i].StatusId === 3 ||  (selectedRowsData[i].CategoryId === 1 && selectedRowsData[i].StatusId === 2 && this.allowEditUnconfirmed)) {
            rowsToDelete.push(selectedRowsData[i]);
          }
        }

        if (rowsToDelete.length > 0) {
          
          let timeIds = [];
          rowsToDelete.forEach(row => {
            
            if (row.MondayTimeId > 0) {
              timeIds.push(row.MondayTimeId);
            }
            if (row.TuesdayTimeId > 0) {
              timeIds.push(row.TuesdayTimeId);
            }
            if (row.WednesdayTimeId > 0) {
              timeIds.push(row.WednesdayTimeId);
            }
            if (row.ThursdayTimeId > 0) {
              timeIds.push(row.ThursdayTimeId);
            }
            if (row.FridayTimeId > 0) {
              timeIds.push(row.FridayTimeId);
            }
            if (row.SaturdayTimeId > 0) {
              timeIds.push(row.SaturdayTimeId);
            }
            if (row.SundayTimeId > 0) {
              timeIds.push(row.SundayTimeId);
            }
          });

          
          if (timeIds.length > 0) {
            if (timeIds.length > 100) {
              let startIndex = 0;
              let endIndex = 100;
              let arrayRequests = [];
              while (endIndex <= timeIds.length) {
                let timeIdsSliced = timeIds.slice(startIndex, endIndex);
                if (timeIdsSliced.length === 0) {
                  break;
                }
                
                let requestDelete = this.timeService.deleteTimeByTimeIds(timeIdsSliced);
                arrayRequests.push(requestDelete);
                startIndex = endIndex;
                endIndex = endIndex + 100 > timeIds.length ? timeIds.length : endIndex + 100;
                if (startIndex > timeIds.length) {
                  break;
                }
              }
              forkJoin(arrayRequests).toPromise().then(results => {
                
                if (results.length > 0) {
                  for (let i = 0; i < results.length; i++) {
                    let result: any;
                    result = results[i];
                    if (result.Message.length > 0) {
                      this.amsNotifierService.error(result.Message);
                    }
                  }
                }
                this.amsNotifierService.success(this.languageService.LNG("Label.DeletedOK"));
                this.loading.emit(false);
                this.loadListRecords(false);
                this.dataGrid.selectedRowKeys = [];
              });
            }
            else {
              this.timeService.deleteTimeByTimeIds(timeIds).subscribe((result: any) => { // success path
                
                this.amsNotifierService.success(this.languageService.LNG("Label.DeletedOK"));
                if (result.Message != null && result.Message.length > 0) {
                  this.amsNotifierService.error(result.Message);
                }
                this.loading.emit(false);
                this.onRefresh();
                this.dataGrid.selectedRowKeys = [];
                // this.dataGrid.instance.refresh();
              }, error => { // error path;  
                this.loading.emit(false);
              });
            }
          }
          else {
            this.amsNotifierService.info(this.languageService.LNG("Label.No.Time.Posts.To.Delete"));
            this.loading.emit(false);
          }
        }
        else { 
          this.loading.emit(false);   
          this.amsNotifierService.info(this.languageService.LNG("Label.No.Time.Posts.To.Delete"));
        }
      }
      else {
        this.amsNotifierService.info(this.languageService.LNG("Label.Please.Select.Rows.To.Delete"));
        this.loading.emit(false);
      }
    }
    });
  }

  @Input()
  set setSelectedDate(selectedDate: Date) {
    
    this.selectedDate = selectedDate;
    this.weekno_text = this.dateTimeFunctions.findWeekFromDate(this.selectedDate);
    this.setDayHeaders();
  }

  prevWeek_Click() {
    
    this.selectedDate.setDate(this.selectedDate.getDate() - 7);
    this.weekno_text = this.dateTimeFunctions.findWeekFromDate(this.selectedDate);
    this.setDayHeaders();
    this.loadListRecords(false);
  }

  nextWeek_Click() {
    
    this.selectedDate.setDate(this.selectedDate.getDate() + 7);
    this.weekno_text = this.dateTimeFunctions.findWeekFromDate(this.selectedDate);
    this.setDayHeaders();
    this.loadListRecords(false);
  }

  today_Click() {
    this.selectedDate = new Date();
    this.weekno_text = this.dateTimeFunctions.findWeekFromDate(this.selectedDate);
    this.setDayHeaders();
    this.loadListRecords(false);
  }

  weekChanged(e) {
    
    this.selectedDate = e.value;
    this.weekno_text = this.dateTimeFunctions.findWeekFromDate(this.selectedDate);
    this.setDayHeaders();
    this.loadListRecords(false);
  }

  focusHHmm(e) {
    e.event.target.select();
  }

  //tab to minute field when tabbing from hour field. default behaviour of datagrid is tabbing to next gridcolumn
  onKeyDownHH(e) {
    
    if (!e.event.shiftKey && e.event.keyCode === 9) {
      
      e.event.stopImmediatePropagation();
    }
  }

  onKeyDownMinutes(e, cell, daynumber) {
    
    if (cell.text.length >= 2) {
      cell.setValue(cell.text);
      e.event.preventDefault();
    }
  }

  calculateSummary(options) {
    
    // Calculating "customSummary1"
    if(options.name == "customSumMonday") {
        switch(options.summaryProcess) {
            case "start":
                // Initializing "totalValue" here
                options.totalValue = 0;
                break;
            case "calculate":
                if (options.value.MondaySeconds > 0)
                {
                  options.totalValue += options.value.MondaySeconds;
                }
                // Modifying "totalValue" here
                break;
            case "finalize":
                // Assigning the final value to "totalValue" here
                let hours = options.totalValue / 3600;
                let min = (options.totalValue / 60) % 60;
                options.totalValue = Math.floor(hours) + "t " + Math.floor(min) + "min";
                break;
        }
    }
    if(options.name == "customSumTuesday") {
        switch(options.summaryProcess) {
            case "start":
                // Initializing "totalValue" here
                options.totalValue = 0;
                break;
            case "calculate":
                if (options.value.TuesdaySeconds > 0)
                {
                  options.totalValue += options.value.TuesdaySeconds;
                }
                // Modifying "totalValue" here
                break;
            case "finalize":
                // Assigning the final value to "totalValue" here
                let hours = options.totalValue / 3600;
                let min = (options.totalValue / 60) % 60;
                options.totalValue = Math.floor(hours) + "t " + Math.floor(min) + "min";
                break;
        }
    }
    if(options.name == "customSumWednesday") {
        switch(options.summaryProcess) {
            case "start":
                // Initializing "totalValue" here
                options.totalValue = 0;
                break;
            case "calculate":
                if (options.value.WednesdaySeconds > 0)
                {
                  options.totalValue += options.value.WednesdaySeconds;
                }
                // Modifying "totalValue" here
                break;
            case "finalize":
                // Assigning the final value to "totalValue" here
                let hours = options.totalValue / 3600;
                let min = (options.totalValue / 60) % 60;
                options.totalValue = Math.floor(hours) + "t " + Math.floor(min) + "min";
                break;
        }
    }
    if(options.name == "customSumThursday") {
        switch(options.summaryProcess) {
            case "start":
                // Initializing "totalValue" here
                options.totalValue = 0;
                break;
            case "calculate":
                if (options.value.ThursdaySeconds > 0)
                {
                  options.totalValue += options.value.ThursdaySeconds;
                }
                // Modifying "totalValue" here
                break;
            case "finalize":
                // Assigning the final value to "totalValue" here
                let hours = options.totalValue / 3600;
                let min = (options.totalValue / 60) % 60;
                options.totalValue = Math.floor(hours) + "t " + Math.floor(min) + "min";
                break;
        }
    }
    if(options.name == "customSumFriday") {
        switch(options.summaryProcess) {
            case "start":
                // Initializing "totalValue" here
                options.totalValue = 0;
                break;
            case "calculate":
                if (options.value.FridaySeconds > 0)
                {
                  options.totalValue += options.value.FridaySeconds;
                }
                // Modifying "totalValue" here
                break;
            case "finalize":
                // Assigning the final value to "totalValue" here
                let hours = options.totalValue / 3600;
                let min = (options.totalValue / 60) % 60;
                options.totalValue = Math.floor(hours) + "t " + Math.floor(min) + "min";
                break;
        }
    }
    if(options.name == "customSumSaturday") {
        switch(options.summaryProcess) {
            case "start":
                // Initializing "totalValue" here
                options.totalValue = 0;
                break;
            case "calculate":
                if (options.value.SaturdaySeconds > 0)
                {
                  options.totalValue += options.value.SaturdaySeconds;
                }
                // Modifying "totalValue" here
                break;
            case "finalize":
                // Assigning the final value to "totalValue" here
                let hours = options.totalValue / 3600;
                let min = (options.totalValue / 60) % 60;
                options.totalValue = Math.floor(hours) + "t " + Math.floor(min) + "min";
                break;
        }
    }
    if(options.name == "customSumSunday") {
        switch(options.summaryProcess) {
            case "start":
                // Initializing "totalValue" here
                options.totalValue = 0;
                break;
            case "calculate":
                if (options.value.SundaySeconds > 0)
                {
                  options.totalValue += options.value.SundaySeconds;
                }
                // Modifying "totalValue" here
                break;
            case "finalize":
                // Assigning the final value to "totalValue" here
                let hours = options.totalValue / 3600;
                let min = (options.totalValue / 60) % 60;
                options.totalValue = Math.floor(hours) + "t " + Math.floor(min) + "min";
                break;
        }
    }
    if(options.name == "customSumTotal") {
        switch(options.summaryProcess) {
            case "start":
                // Initializing "totalValue" here
                options.totalValue = 0;
                break;
            case "calculate":
                if (options.value.MondaySeconds > 0 ||
                  options.value.TuesdaySeconds > 0 ||
                  options.value.WednesdaySeconds > 0 ||
                  options.value.ThursdaySeconds > 0 ||
                  options.value.FridaySeconds > 0 ||
                  options.value.SaturdaySeconds > 0 ||
                  options.value.SundaySeconds > 0)
                {
                  options.totalValue += options.value.MondaySeconds + 
                                        options.value.TuesdaySeconds +
                                        options.value.WednesdaySeconds +
                                        options.value.ThursdaySeconds +
                                        options.value.FridaySeconds +
                                        options.value.SaturdaySeconds +
                                        options.value.SundaySeconds;
                }
                // Modifying "totalValue" here
                break;
            case "finalize":
                // Assigning the final value to "totalValue" here
                let hours = options.totalValue / 3600;
                let min = (options.totalValue / 60) % 60;
                options.totalValue = Math.floor(hours) + "t " + Math.floor(min) + "min";
                break;
        }
    }
  }

  //needed to get values to hours and minute-boxes from displayValue because getting them from cell.data.MondaySecondsToHH f.ex does not get updated after first column has changed. tried this in the onValueChangedHours and onValueChangedMinutes functions
  getValueHours(cell) {
    
    let displayValue = cell.displayValue;
    if (displayValue) {
      var h = Math.floor(displayValue / 3600);
      var m = Math.floor(displayValue % 3600 / 60);
      // let indxT = displayValue.indexOf("t");
      // let indxm = displayValue.indexOf("m");
      // let hours = Number(displayValue.substring(0, indxT));
      // let min = Number(displayValue.substring(indxT + 1, indxm));

      return h;
    }
    else
    {
      return "";
    }
  }

  getValueMin(cell) {
    let displayValue = cell.displayValue;
    if (displayValue) {
      var h = Math.floor(displayValue / 3600);
      var m = Math.floor(displayValue % 3600 / 60);
      // let indxT = displayValue.indexOf("t");
      // let indxm = displayValue.indexOf("m");
      // let hours = Number(displayValue.substring(0, indxT));
      // let min = Number(displayValue.substring(indxT + 1, indxm));

      return m;
    }
    else {
      return "";
    }
  }

  onInitNewRow(e) {
    
    if (!this.isClone) {
      e.data.ProjectId = -1;
      e.data.ProjectDisplayName = "";
      if (this.employees && this.employees.length === 1) {
        e.data.EmployeeId = this.employees[0].EmployeeId;
      }
    }
    else {
      //clone project and employee
      e.data.ProjectId = this.cloneData.ProjectId;
      e.data.ProjectDisplayName = this.cloneData.ProjectDisplayName;
      e.data.CustomerId = this.cloneData.CustomerId;
      e.data.EmployeeId = this.cloneData.EmployeeId;
      e.data.EmployeeName = this.cloneData.EmployeeName;
    }
    this.isClone = false;
  }

  projectTemplate(e) {
    
  }

  onProjectValueChanged(e, cell) {
    
    let selectedProject = e.component.option("selectedItem");
    if (selectedProject) {
      cell.setValue(selectedProject);
      // cell.data.ProjectId = selectedProject.ProjectId;
      // cell.data.ProjectDisplayName = selectedProject.ProjectDisplayName;
      // cell.data.CustomerId = selectedProject.CustomerId;
    }
  }
  setProjectValue(newData, value) {
    
    newData.ProjectId = value && value.ProjectId;
    newData.ProjectDisplayName = value && value.ProjectDisplayName;
    newData.CustomerId = value && value.CustomerId;
  }
  onEmployeeValueChanged(e, cell) {
    
    let selectedEmployee = e.component.option("selectedItem");
    if (selectedEmployee) {
      let employee = {
        EmployeeId: selectedEmployee.EmployeeId,
        EmployeeName: selectedEmployee.FullName
      }
      cell.setValue(employee);
      // cell.data.EmployeeId = selectedEmployee.EmployeeId;
    }
  }
  setEmployeeValue(newData, value) {
    
    newData.EmployeeId = value && value.EmployeeId;
    newData.EmployeeName = value && value.EmployeeName;
  }

  onTimeTypeValueChanged(e, cell) {
    let selectedTimeType = e.component.option("selectedItem");
    if (selectedTimeType) {
      let timetype = {
        TimeTypeId: selectedTimeType.TimeTypeId,
        TimeTypeDisplayName: selectedTimeType.Code
      }
      cell.setValue(timetype);
    }
  }

  setTimeTypeValue(newData, value) {
    
    newData.TimeTypeId = value && value.TimeTypeId;
    newData.TimeTypeDisplayName = value && value.TimeTypeDisplayName;
  }

  setHHmmValue(newData, value) {
    
    switch  (value.DayNumber) {
      case 1:
        newData.MondaySeconds = value && value.MondaySeconds;
        newData.MondayToHHmm = value && value.MondayToHHmm;
        value.MinuteBoxItem.firstChild.firstChild.firstChild.firstChild.focus();
        break;
      case 2:
        newData.TuesdaySeconds = value && value.TuesdaySeconds;
        newData.TuesdayToHHmm = value && value.TuesdayToHHmm;
        break;
    }
  }

  onRowPrepared(e) {
    
    if(e.isEditing) {
      
      var cellElements = e.rowElement.children(":not(.dx-command-edit)");
      
      cellElements.first().on("keydown", function(event) {
        
          if(event.keyCode === 9 && event.shiftKey) {
              event.preventDefault();
              e.component.focus(cellElements.last());
          }
      });

      cellElements.last().on("keydown", function(event) {
        
          if(event.keyCode === 9 && !event.shiftKey) {
              event.preventDefault();
              e.component.focus(cellElements.first());
          }
      });
    }
  }

  thiccBorderLeft(caption) {
    // if (caption == this.mondayHeader || 
    //   caption == this.tuesdayHeader || 
    //   caption == this.wednesdayHeader || 
    //   caption == this.thursdayHeader || 
    //   caption == this.fridayHeader || 
    //   caption == this.saturdayHeader || 
    //   caption == this.sundayHeader) {
    //     return true;
    //   }
    //   else {
    //     return false;
    //   }
    if (this.colSeparatorCaptions.find(c => c === caption)) {
      return true;
    }
    else {
      return false;
    }
  }

  onCellPrepared(e) {
    
    if ((e.rowType == "header" || e.rowType == "data") && this.thiccBorderLeft(e.column.caption)) {
      // e.cellElement.style.borderLeftColor = '#EDEDED';
      e.cellElement.style.borderLeftStyle = 'solid';
      e.cellElement.style.borderLeftWidth = '4px';
      // return;
    }
    // if (e.rowType === "data")

    // //do not allow edit on confirmed time posts(statusid=4) and categoryid=1 when user is admin
    // if (e.column.type === "buttons" && ((this.userService.account.IsAdmin) && (e.data.CategoryId === 1 || e.data.StatusId === 4)
    // || (!this.userService.account.IsAdmin && (e.data.StatusId === 3 || e.data.StatusId === 4) ))) {
    // // if ((e.column.type === "buttons" || e.columnIndex === 0) && e.data.StatusId === 4 ) {
    //   // e.cellElement.find(".dx-link-edit").remove();
    //   for (let i = 0; i < e.cellElement.children.length; i++) {
    //     let child = e.cellElement.children[i];
    //     child.style.display = 'none';
    //   }
    // }


    this.cellPrepared.emit(e);
  }

  onEditorPreparing(e) {
    if(e.parentType == "dataRow"){
             
      e.editorOptions.onFocusIn = function(args) {
        const input = args.element.querySelector('.dx-texteditor-input');
        if (input !== null && input !== undefined) {
          input.select();
        }
      }          
    }
    if (e.dataField === "MondaySecondsToHH" || e.dataField === "MondaySecondsTomm" || 
        e.dataField === "TuesdaySecondsToHH" || e.dataField === "TuesdaySecondsTomm" || 
        e.dataField === "WednesdaySecondsToHH" || e.dataField === "WednesdaySecondsTomm" || 
        e.dataField === "ThursdaySecondsToHH" || e.dataField === "ThursdaySecondsTomm" || 
        e.dataField === "FridaySecondsToHH" || e.dataField === "FridaySecondsTomm" || 
        e.dataField === "SaturdaySecondsToHH" || e.dataField === "SaturdaySecondsTomm" || 
        e.dataField === "SundaySecondsToHH" || e.dataField === "SundaySecondsTomm") {
      if (e.row.data.StatusId >= 4 || 
        (e.row.data.CategoryId === 1 && e.row.data.StatusId === 2 && !this.allowEditUnconfirmed) || 
        (e.row.data.CategoryId === 7 && e.row.data.StatusId === 2 && !this.allowEditUnconfirmed) || 
        (e.row.data.StatusId === 3 && !this.allowEditConfirmed) ||
        (!this.allowEditUnconfirmed && !this.allowEditConfirmed)) {
        // e.showEditorAlways = false;
        e.readOnly = true;
        e.editorOptions.disabled = true;
      }
    }
  }

  onValueChangedHoursMon(e, cell, daynumber) {
    
    
    let newValue: number;
    newValue = Number(e.value);
    // cell.data.MondaySecondsToHH = newValue;
    let minutesMon = cell.data.MondaySecondsTomm;
    let newHHSeconds = newValue * 3600;
    let secondsMon = newHHSeconds + (Number(minutesMon) * 60);
    cell.setValue(secondsMon);

  }

  onValueChangedMinutesMon(e, cell, daynumber) {
    
    let newValue: number;
    newValue = Number(e.value);
    let newMinSeconds = newValue * 60;
    let hoursMon = cell.data.MondaySecondsToHH;
    let secondsMon = newMinSeconds + (Number(hoursMon) * 3600);
    cell.setValue(secondsMon);
  }

  getTMINFromSeconds (seconds) {
    let hours = seconds / 3600
    let min = (seconds / 60) % 60;
    return hours + "t " + min + "m";
  }

  setMondayHHValue(newData, value) {
    
    newData.MondaySecondsToHH = value;
  }

  setMondaymmValue(newData, value) {
    
    newData.MondaySeconds = value;
    
    let hours = value / 3600;
    let min = (value / 60) % 60;
    newData.MondaySecondsToHH = hours;
    newData.MondaySecondsTomm = min;
    newData.MondayToHHmm = hours + "t " + min + "m";
    // newData.MondayToHHmm = this.getTMINFromSeconds(value);
  }

  setMondayValue(newData, value) {
    
    newData.MondaySeconds = value;
    
    let hours = value / 3600;
    let min = (value / 60) % 60;
    newData.MondaySecondsToHH = hours;
    newData.MondaySecondsTomm = min;
    newData.MondayToHHmm = hours + "t " + min + "m";
    // newData.MondayToHHmm = this.getTMINFromSeconds(value);
  }

  setTuesdayValue(newData, value) {
    
    newData.TuesdaySeconds = value;
    let hours = value / 3600
    let min = (value / 60) % 60;
    newData.TuesdayToHHmm = hours + "t " + min + "m";
    // newData.TuesdayToHHmm = this.getTMINFromSeconds(value);
  }

  setWednesdayValue(newData, value) {
    
    newData.WednesdaySeconds = value;
    let hours = value / 3600
    let min = (value / 60) % 60;
    newData.WednesdayToHHmm = hours + "t " + min + "m";
    // newData.WednesdayToHHmm = this.getTMINFromSeconds(value);
  }

  setThursdayValue(newData, value) {
    
    newData.ThursdaySeconds = value;
    let hours = value / 3600
    let min = (value / 60) % 60;
    newData.ThursdayToHHmm = hours + "t " + min + "m";
    // newData.ThursdayToHHmm = this.getTMINFromSeconds(value);
  }

  setFridayValue(newData, value) {
    
    newData.FridaySeconds = value;
    let hours = value / 3600
    let min = (value / 60) % 60;
    newData.FridayToHHmm = hours + "t " + min + "m";
    // newData.FridayToHHmm = this.getTMINFromSeconds(value);
  }

  setSaturdayValue(newData, value) {
    
    newData.SaturdaySeconds = value;
    let hours = value / 3600
    let min = (value / 60) % 60;
    newData.SaturdayToHHmm = hours + "t " + min + "m";
    // newData.SaturdayToHHmm = this.getTMINFromSeconds(value);
  }

  setSundayValue(newData, value) {
    
    newData.SundaySeconds = value;
    let hours = value / 3600
    let min = (value / 60) % 60;
    newData.SundayToHHmm = hours + "t " + min + "m";
    // newData.SundayToHHmm = this.getTMINFromSeconds(value);
  }

  onValueChangedHours(e, cell, daynumber) {
    
    let newValue: number;
    newValue = Number(e.value);
    let newHHSeconds = newValue * 3600;
    switch (daynumber) {
      case 1:
        // cell.data.MondaySecondsToHH = newValue;
        // cell.data.MondaySecondsTomm = cell.data.MondaySecondsTomm ? cell.data.MondaySecondsTomm : 0;
        let minutesMon = cell.data.MondaySecondsTomm ? cell.data.MondaySecondsTomm : 0;
        let secondsMon = newHHSeconds + (Number(minutesMon) * 60);
        cell.setValue(secondsMon);
        break;
      case 2:
        // cell.data.TuesdaySecondsToHH = newValue;
        // cell.data.TuesdaySecondsTomm = cell.data.TuesdaySecondsTomm? cell.data.TuesdaySecondsTomm : 0 ;
        let minutesTue = cell.data.TuesdaySecondsTomm ? cell.data.TuesdaySecondsTomm : 0;
        let secondsTue = newHHSeconds + (Number(minutesTue) * 60);
        cell.setValue(secondsTue);
        break;
      case 3:
        // cell.data.WednesdaySecondsToHH = newValue;
        // cell.data.WednesdaySecondsTomm = cell.data.WednesdaySecondsTomm ? cell.data.WednesdaySecondsTomm : 0;
        let minutesWed = cell.data.WednesdaySecondsTomm ? cell.data.WednesdaySecondsTomm : 0;
        let secondsWed = newHHSeconds + (Number(minutesWed) * 60);
        cell.setValue(secondsWed);
        break;
      case 4:
        // cell.data.ThursdaySecondsToHH = newValue;
        // cell.data.ThursdaySecondsTomm = cell.data.ThursdaySecondsTomm ? cell.data.ThursdaySecondsTomm : 0;
        let minutesThu = cell.data.ThursdaySecondsTomm ? cell.data.ThursdaySecondsTomm : 0;
        let secondsThu = newHHSeconds + (Number(minutesThu) * 60);
        cell.setValue(secondsThu);
        break;
      case 5:
        // cell.data.FridaySecondsToHH = newValue;
        // cell.data.FridaySecondsTomm = cell.data.FridaySecondsTomm ? cell.data.FridaySecondsTomm : 0;
        let minutesFri = cell.data.FridaySecondsTomm ? cell.data.FridaySecondsTomm : 0;
        let secondsFri = newHHSeconds + (Number(minutesFri) * 60);
        cell.setValue(secondsFri);
        break;
      case 6:
        // cell.data.SaturdaySecondsToHH = newValue;
        // cell.data.SaturdaySecondsTomm = cell.data.SaturdaySecondsTomm ? cell.data.SaturdaySecondsTomm : 0;
        let minutesSat = cell.data.SaturdaySecondsTomm ? cell.data.SaturdaySecondsTomm : 0;
        let secondsSat = newHHSeconds + (Number(minutesSat) * 60);
        cell.setValue(secondsSat);
        break;
      case 7:
        // cell.data.SundaySecondsToHH = newValue;
        // cell.data.SundaySecondsTomm = cell.data.SundaySecondsTomm ? cell.data.SundaySecondsTomm : 0;
        let minutesSun = cell.data.SundaySecondsTomm ? cell.data.SundaySecondsTomm : 0;
        let secondsSun = newHHSeconds + (Number(minutesSun) * 60);
        cell.setValue(secondsSun);
        break;
      default:
    }
  }

  onValueChangedMinutes(e, cell, daynumber) {
    
    
    let newValue: number;
    newValue = Number(e.value);
    let newMinSeconds = newValue * 60;
    switch (daynumber) {
      case 1:
        cell.data.MondaySecondsTomm = newValue;
        // cell.data.MondaySecondsToHH = cell.data.MondaySecondsToHH ? cell.data.MondaySecondsToHH : 0;
        // let hoursMon = cell.data.MondaySecondsToHH;
        // let secondsMon = newMinSeconds + (Number(hoursMon) * 3600);
        cell.setValue(newValue);
        break;
      case 2:
        cell.data.TuesdaySecondsTomm = newValue;
        // cell.data.TuesdaySecondsToHH = cell.data.TuesdaySecondsToHH ? cell.data.TuesdaySecondsToHH : 0;
        // let hoursTue = cell.data.TuesdaySecondsToHH;
        // let secondsTue = newMinSeconds + (Number(hoursTue) * 3600);
        cell.setValue(newValue);
        break;
      case 3:
        // cell.data.WednesdaySecondsTomm = newValue;
        // cell.data.WednesdaySecondsToHH = cell.data.WednesdaySecondsToHH ? cell.data.WednesdaySecondsToHH : 0;
        let hoursWed = cell.data.WednesdaySecondsToHH ? cell.data.WednesdaySecondsToHH : 0;
        let secondsWed = newMinSeconds + (Number(hoursWed) * 3600);
        cell.setValue(secondsWed);
        break;
      case 4:
        // cell.data.ThursdaySecondsTomm = newValue;
        // cell.data.ThursdaySecondsToHH = cell.data.ThursdaySecondsToHH ? cell.data.ThursdaySecondsToHH : 0;
        let hoursThu = cell.data.ThursdaySecondsToHH ? cell.data.ThursdaySecondsToHH : 0;
        let secondsThu = newMinSeconds + (Number(hoursThu) * 3600);
        cell.setValue(secondsThu);
        break;
      case 5:
        // cell.data.FridaySecondsTomm = newValue;
        // cell.data.FridaySecondsToHH = cell.data.FridaySecondsToHH ? cell.data.FridaySecondsToHH : 0;
        let hoursFri = cell.data.FridaySecondsToHH ? cell.data.FridaySecondsToHH : 0;
        let secondsFri = newMinSeconds + (Number(hoursFri) * 3600);
        cell.setValue(secondsFri);
        break;
      case 6:
        // cell.data.SaturdaySecondsTomm = newValue;
        // cell.data.SaturdaySecondsToHH = cell.data.SaturdaySecondsToHH ? cell.data.SaturdaySecondsToHH : 0;
        let hoursSat = cell.data.SaturdaySecondsToHH ? cell.data.SaturdaySecondsToHH : 0;
        let secondsSat = newMinSeconds + (Number(hoursSat) * 3600);
        cell.setValue(secondsSat);
        break;
      case 7:
        // cell.data.SundaySecondsTomm = newValue;
        // cell.data.SundaySecondsToHH = cell.data.SundaySecondsToHH ? cell.data.SundaySecondsToHH : 0;
        let hoursSun = cell.data.SundaySecondsToHH ? cell.data.SundaySecondsToHH : 0;
        let secondsSun = newMinSeconds + (Number(hoursSun) * 3600);
        cell.setValue(secondsSun);
        break;
      default:
    }
  }

  loadListRecords(refreshSearchCriterias: boolean = true, employeeId?: number) {
    
    //send all employeeids if none are selected
    let employeeIds = [];
    if (this.employees) {
      this.employees.forEach(element => {
        employeeIds.push(element.EmployeeId);
      });
      //if only one employee, then only search for this employee
      if (employeeId !== null && employeeId !== undefined && employeeId > 0) {
        this.selectedEmployeeId = employeeId;
      }
      else {
        if (this.employees && this.employees.length === 1) {
          this.selectedEmployeeId = this.employees[0].EmployeeId;
        }
      }
      if (this.selectedEmployeeId > 0) {
        
        employeeIds = [this.selectedEmployeeId];
      }
    }

    let viewModel = {
      ProjectIds: this.projectIdsDataSource,
      SelectedDate: this.selectedDate,
      EmployeeIds: employeeIds,
      RefreshSearchCriterias: refreshSearchCriterias,
      IsSupervisor: this.userService.account.IsSupervisor,
    }
    if (refreshSearchCriterias) {
      this.clearDataGridSelections();
    }
    this.loadRecords.emit(viewModel);
  }

  clearDataGridSelections() {
    
    this.dataGrid.instance.clearFilter();
    this.dataGrid.instance.clearGrouping();
    this.dataGrid.instance.clearSelection();
    this.dataGrid.instance.clearSorting();
  }

  onRowInserting(e) {
    
    e.data.MondaySeconds = this.getSeconds(e.data.MondaySecondsToHH, e.data.MondaySecondsTomm);
    e.data.TuesdaySeconds = this.getSeconds(e.data.TuesdaySecondsToHH, e.data.TuesdaySecondsTomm);
    e.data.WednesdaySeconds = this.getSeconds(e.data.WednesdaySecondsToHH, e.data.WednesdaySecondsTomm);
    e.data.ThursdaySeconds = this.getSeconds(e.data.ThursdaySecondsToHH, e.data.ThursdaySecondsTomm);
    e.data.FridaySeconds = this.getSeconds(e.data.FridaySecondsToHH, e.data.FridaySecondsTomm);
    e.data.SaturdaySeconds = this.getSeconds(e.data.SaturdaySecondsToHH, e.data.SaturdaySecondsTomm);
    e.data.SundaySeconds = this.getSeconds(e.data.SundaySecondsToHH, e.data.SundaySecondsTomm);
    
    this.rowInserting.emit(e);
  }

  onRowUpdating(e) {
    
    for (var property in e.oldData) {
      if (!e.newData.hasOwnProperty(property)) {
          e.newData[property] = e.oldData[property];
      }
    }

    e.newData.MondaySeconds = this.getSeconds(e.newData.MondaySecondsToHH, e.newData.MondaySecondsTomm);
    e.newData.TuesdaySeconds = this.getSeconds(e.newData.TuesdaySecondsToHH, e.newData.TuesdaySecondsTomm);
    e.newData.WednesdaySeconds = this.getSeconds(e.newData.WednesdaySecondsToHH, e.newData.WednesdaySecondsTomm);
    e.newData.ThursdaySeconds = this.getSeconds(e.newData.ThursdaySecondsToHH, e.newData.ThursdaySecondsTomm);
    e.newData.FridaySeconds = this.getSeconds(e.newData.FridaySecondsToHH, e.newData.FridaySecondsTomm);
    e.newData.SaturdaySeconds = this.getSeconds(e.newData.SaturdaySecondsToHH, e.newData.SaturdaySecondsTomm);
    e.newData.SundaySeconds = this.getSeconds(e.newData.SundaySecondsToHH, e.newData.SundaySecondsTomm);

    this.updatedObject = e.newData;
    this.rowUpdating.emit(e);
  }

  

  getSeconds(hours, minutes): number {
    
    if (!hours) {
      hours = 0;
    }
    if (!minutes) {
      minutes = 0;
    }
    let newHHSeconds = hours * 3600;
    return newHHSeconds + (Number(minutes) * 60);

  }

  onRowUpdated(e) {
    
  }

  showPopupProject(selectedProjectId, selectedCustomerId, cell) {
    
    this.popupVisible = true;
    this.selectedProjectIdPopup = selectedProjectId ? selectedProjectId : -1;
    if (selectedProjectId <= 0 || !selectedProjectId) {
      this.selectedCustomerIdPopup = -1;
    }
    this.fromCellPopup = cell;
    // this.fromCellSelectItem = this.fromCellPopup.cellElement.firstChild.firstChild.firstChild.firstChild.firstChild.firstChild;
  }

  onPopupCustomerChanged(e) {
    
    this.projectPopupSearchEnabled = false;
    // this.projectPopupDataSource.filter(['CustomerId', '=', e.value]);
    this.selectedCustomerIdPopup = e.value;
    this.projectsPopupDataSource.reload();
  }

  onPopupProjectChanged(e) {
    
    this.selectedCustomerIdPopup = e.selectedItem.CustomerId;
    this.selectedProjectItemPopup = e.selectedItem;
  }

  //when ok is clicked, then set cellvalue using setValue and also set cell.data so that the correct data is displayed in the selectbox
  onClickPopupSelectedProject(e) {
    
    this.popupVisible = false;
    this.fromCellPopup.setValue(this.selectedProjectItemPopup);
    this.dataGrid.instance.editCell(this.fromCellPopup.rowIndex,0);
  }

  onRefresh() {
    this.dataGrid.instance.cancelEditData();
    this.dataGrid.instance.refresh();
  }

  onConfirm () {
    
    this.loading.emit(true);
    let selectedRowsData = this.dataGrid.instance.getSelectedRowsData();
    let rowsToConfirm = [];
    for (let i = 0; i < selectedRowsData.length; i++) {
      if (selectedRowsData[i].StatusId === 2 && selectedRowsData[i].CategoryId === 1) {
        rowsToConfirm.push(selectedRowsData[i]);
      }
    }

    if (rowsToConfirm.length > 0) {
      this.projectService.confirmWeekApproval(rowsToConfirm).subscribe((result: any) => { // success path
        
        this.loading.emit(false);
        this.dataGrid.selectedRowKeys = [];
        this.onRefresh();
      }, error => { // error path;    
        this.loading.emit(false);    
      });
    }
    else { 
      this.loading.emit(false);   
      this.amsNotifierService.info(this.languageService.LNG("Label.No.Time.Posts.To.Confirm"));
    }
  }

  onApprove () {
    this.loading.emit(true);
    let selectedRowsData = this.dataGrid.instance.getSelectedRowsData();
    let rowsToApprove = [];
    let errorMessageNoRows = this.languageService.LNG("Label.No.Time.Posts.To.Approve");
    for (let i = 0; i < selectedRowsData.length; i++) {
        //Eirik 11.06.21 v2.0.32.9 task 1200 - if user is supervisor and the time post has another SupervisorId, then make it unapprovable for user
        if (!this.userService.account.IsAdmin && selectedRowsData[i].SupervisorId != null && this.userService.account.IsSupervisor &&
          selectedRowsData[i].SupervisorId != this.userService.account.EmployeeId  &&
          (this.userService.account.IsAdmin || this.userService.account.IsSupervisor)) {
            errorMessageNoRows = this.languageService.LNG("Label.Cannot.Approve.Time.Posts.Registered.On.Another.Supervisor");
            continue;
        }
        rowsToApprove.push(selectedRowsData[i]);
    }

    if (rowsToApprove.length > 0) {
      this.projectService.approveWeekApproval(rowsToApprove).subscribe((result: any) => { // success path
        
        this.loading.emit(false);
        if (result.IsSuccess) {
          if (result.Message !== null && result.Message.length > 0) {
            this.amsNotifierService.error(result.Message);
          }
          this.dataGrid.selectedRowKeys = [];
          this.amsNotifierService.success(this.languageService.LNG("Label.Is.Approved"));
          this.onRefresh();
        }
        else {
          this.amsNotifierService.error(result.ErrorMessage);
        }

      }, error => { // error path;    
        this.loading.emit(false);    
      });
    }
    else { 
      this.amsNotifierService.info(errorMessageNoRows);
      this.loading.emit(false);   
    }
  }

  getSelectedRowsData() {
    return this.dataGrid.instance.getSelectedRowsData();
  }

  onReset(statusId): Promise<boolean> {
    this.loading.emit(true);
    return new Promise(resolve => {
      let selectedRowsData = this.dataGrid.instance.getSelectedRowsData();
      let rowsToReset = [];
      let errorMessageNoRows = this.languageService.LNG("Label.No.Time.Posts.To.Approve");
      for (let i = 0; i < selectedRowsData.length; i++) {
          //Eirik 11.06.21 v2.0.32.9 task 1200 - if user is supervisor and the time post has another SupervisorId, then make it unapprovable for user
          if (!this.userService.account.IsAdmin && selectedRowsData[i].SupervisorId != null && this.userService.account.IsSupervisor &&
            selectedRowsData[i].SupervisorId != this.userService.account.EmployeeId  &&
            (this.userService.account.IsAdmin || this.userService.account.IsSupervisor)) {
              errorMessageNoRows = this.languageService.LNG("Label.Cannot.Approve.Time.Posts.Registered.On.Another.Supervisor");
              continue;
          }
          rowsToReset.push(selectedRowsData[i]);
      }

      if (rowsToReset.length > 0) {
        this.projectService.resetWeekApproval(rowsToReset, statusId).subscribe((result: any) => { // success path
          this.loading.emit(false);
          if (result.IsSuccess) {
            if (result.Message !== null && result.Message.length > 0) {
              this.amsNotifierService.error(result.Message);
            }
            this.dataGrid.selectedRowKeys = [];
            this.amsNotifierService.success(this.languageService.LNG("Label.Reset.Ok"));
            this.onRefresh();
            resolve(true);
          }
          else {
            this.amsNotifierService.error(result.ErrorMessage);
            resolve(false);
          }

        }, error => { // error path;    
          this.loading.emit(false);   
          resolve(false); 
        });
      }
      else { 
        this.amsNotifierService.info(errorMessageNoRows);
        this.loading.emit(false);
        resolve(false);
      }
    });
  }

  onCopyRow(e, cell) {
    
    this.isClone = true;
    this.cloneData = cell.data;
    this.dataGrid.instance.addRow();
  }

  onDeleteRow(e, cell) {
    
    
    this.loading.emit(true);
    this.projectService.deleteWeekApproval(cell.data).subscribe((result: any) => { // success path
      this.loading.emit(false);
      if (result.IsSuccess) {
        this.onRefresh();
        if (result.Message != null && result.Message.length > 0) {
          this.amsNotifierService.error(result.Message);
        }
      }
      else {
        this.amsNotifierService.error(result.ErrorMessage);
      }
    }, error => { // error path;    
      this.loading.emit(false);    
    });
  }

  onSelectionChangedEmployees(e) {
    
    if (e.selectedItem) {
      this.selectedEmployeeId = e.selectedItem.EmployeeId;
    }
    else {
      this.selectedEmployeeId = -1;
    }
    this.loadListRecords(false);
  }

  @Input()
  set setDataSourceWeekApproval(datasource: DataSource) {
    
    this.dataSourceWeekApproval = datasource;
    

  }

  @Input()
  set employeeDataSource(recs: any) {
    
    this.employees = recs;
    if (this.employees && this.employees.length === 1) {
      this.employeeLookUpEnabled = false;
    }
  }

    @Input()
    set employeeDataSourceNotQuit(recs: any) {
        
        this.employeesNotQuit = recs;
        if (this.employeesNotQuit && this.employeesNotQuit.length === 1) {
            this.employeeLookUpEnabled = false;
        }
    }

  @Input()
  set timetypeDataSource(recs: any) {
    
    this.timetypes = recs;
  }

  @Input()
  set selectedEmployeeInput(employeeId: any) {
    
    this.selectedEmployeeId = employeeId;
  }

  @Input()
  set showEmployeeSelect(visible: boolean) {
    
    this.isEmployeeSelectShown = visible;
  }

  @Input()
  set showEmployeeColumn(visible: boolean) {
    
    this.isEmployeeColumnShown = visible;
  }

  @Input()
  set projectIds(ids: any[]) {
    
    this.projectIdsDataSource = ids;
  }

  @Input()
  set setEditMode(mode: string) {
    this.editMode = mode;
  }

  @Input() 
  set setShowUnconfirmed(showUnconfirmed: boolean) {
    
    this.showUnconfirmed = showUnconfirmed;
  }

  dataCellTemplate(e, d) {
    

  }
}
